import { render, staticRenderFns } from "./QuadientAims.vue?vue&type=template&id=b48eded0&scoped=true&"
import script from "./QuadientAims.vue?vue&type=script&lang=js&"
export * from "./QuadientAims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48eded0",
  null
  
)

export default component.exports